// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class PastSignalsResource extends Resource {
    basePath: string = 'cases/signals/';

    objectPath: string = 'cases/signals/{ident}/';
}
